export default __webpack_public_path__ + "static/media/social-discord.e21557a9.png";